import Vue from 'vue';
import { gsap } from 'gsap/all';
import { SplitText } from "../gsap-bonus/SplitText";

import { flipRemove } from '../utils/animation';

Vue.component('chapter-header-component', {
    data() {
        return {
            letterTls: [],
            delay: 0.3
        }
    },

    mounted() {
        this.init();

        EventBus.$on('window-resize', )
    },

    methods: {
        init() {
            this.introArrow = this.$el.querySelector('.intro-text__arrow');
            this.elm = document.querySelector('.chapter-header__number-holder');
            this.titleElement = this.$el.querySelector('.chapter-header__subtitle--split-text');
            this.lineElement = this.$el.querySelector('.chapter-header__subline');

            // window.requestAnimationFrame(this.flipLogo);
            window.requestAnimationFrame(this.initSplitTitle);
            window.requestAnimationFrame(this.animate);

            window.requestAnimationFrame(() => {
                this.introArrow.classList.add('--reveal');

                gsap.to('.intro-text__arrow-holder--chapter', {
                    scrollTrigger: {
                        trigger: '.chapter-header__image-holder',
                        once: false,
                        start: "top top",
                        toggleActions: "play none none reverse"
                    },
                    duration: 1.2,
                    autoAlpha: 0,
                });
            });
        },

        scrollClick() {
            zenscroll.toY(window.innerHeight * 0.75, 1000);
        },

        animate() {
            this.$el.classList.remove('hidden');
            
            gsap.delayedCall(this.delay, () => {
                this.elm.classList.remove('chapter-header__number-holder--flipped');
            });

            if (this.letterTls) {
                for (let index = 0; index < this.letterTls.length; index++) {
                    const tl = this.letterTls[index];
                    tl.play();
                }
            }

            gsap.to('.chapter-header__image', {
                duration: 1.5,
                scale: 1.2,
                delay: this.delay,
                ease: 'power4.easeOut'
            });
        },

        /**
         * Wrap each line in title in a seperate container
         */
        initSplitTitle() {
            if (!this.titleElement) {
                return
            }

            this.titleSplit = new SplitText(this.titleElement, { type: "lines", linesClass: 'home-intro__title-text-line' });

            for (let index = 0; index < this.titleSplit.lines.length; index++) {
                const line = this.titleSplit.lines[index];

                let inner = line.innerHTML;
                inner = `<div class="perspective">${inner}</div>`;
                line.innerHTML = inner;

                const letterSplit = new SplitText(line.querySelector('div'), { type: 'words,chars', wordsClass: 'split-word' });
                gsap.set('.home-intro__title-text-line', { perspective: 800 });

                const tl = gsap.timeline({
                    paused: true
                });

                tl.from(letterSplit.chars, {
                    duration: 0.8,
                    opacity: 0.2,
                    x: 300,
                    rotationY: -120,
                    stagger: 0.05,
                    delay: this.delay,
                    immediateRender: true,
                    filter:`blur(${ 6 }px)`,
                    ease: 'power4.easeOut'
                });

                // The last timeline has to reveal the line.
                if (index === this.titleSplit.lines.length - 1) {
                    tl.eventCallback('onComplete', () => {
                        this.lineElement.classList.add('--reveal');
                    });
                }

                this.letterTls.push(tl);
            }
        },

        flipLogo() {
            const logoHolder = document.querySelector('.chapter-header__number-holder-inner');
            const { x, y } = flipRemove(logoHolder, 'chapter-header__number-holder--flipped');
            
            gsap.set(logoHolder, {
                x, y
            });
        }
    }
});